import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "stats-container"
};
const _hoisted_3 = {
  class: "stat-item"
};
const _hoisted_4 = {
  class: "stat-value",
  style: {
    "margin-right": "10px"
  }
};
const _hoisted_5 = {
  class: "stat-item"
};
const _hoisted_6 = {
  class: "stat-value",
  style: {
    "margin-right": "10px"
  }
};
import { ref, onMounted } from 'vue';
import axios from 'axios';
export default {
  __name: 'footerView',
  setup(__props) {
    const downloads = ref(0);
    const pageviews = ref(0);
    const fetchStats = async () => {
      try {
        const response = await axios.get('https://pabapi.machao.group/OAE/showdownloads');
        console.log(response.data);
        pageviews.value = response.data.totalPageCount;
        downloads.value = response.data.totalDownCount;
      } catch (error) {
        console.error('获取统计信息失败:', error);
      }
    };
    onMounted(() => {
      fetchStats();
      // 监听更新事件
      // window.addEventListener('update-downloads', fetchStats);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createStaticVNode("<div class=\"container\" data-v-0331eca5><div class=\"item\" data-v-0331eca5><div data-v-0331eca5>118 rows</div><div data-v-0331eca5>Cyclostratigraphy</div><div data-v-0331eca5>data</div></div><div class=\"item\" data-v-0331eca5><div data-v-0331eca5>1790 rows</div><div data-v-0331eca5>Chronostratigraphy</div><div data-v-0331eca5>data</div></div><div class=\"item\" data-v-0331eca5><div data-v-0331eca5>693 rows</div><div data-v-0331eca5>Lithology</div><div data-v-0331eca5>data</div></div><div class=\"item\" data-v-0331eca5><div data-v-0331eca5>698 rows</div><div data-v-0331eca5>Chemostratigraphy</div><div data-v-0331eca5>data</div></div><div class=\"item\" data-v-0331eca5><div data-v-0331eca5>15</div><div data-v-0331eca5>formation</div></div><div class=\"item\" data-v-0331eca5><div data-v-0331eca5>270</div><div data-v-0331eca5>collection</div></div><div class=\"item\" data-v-0331eca5><div data-v-0331eca5>27</div><div data-v-0331eca5>reference</div></div></div>", 1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(pageviews.value), 1), _cache[0] || (_cache[0] = _createElementVNode("span", {
        class: "stat-label"
      }, "Visits", -1))]), _createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(downloads.value), 1), _cache[1] || (_cache[1] = _createElementVNode("span", {
        class: "stat-label"
      }, "Downloads", -1))])])]);
    };
  }
};